import { SvgIcon } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const AboutIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 36 36" fill="none" >
            <path d="M33 18C33 22.196 31.2771 25.9896 28.5002 28.712C25.7945 31.3645 22.0883 33 18 33C13.9117 33 10.2055 31.3645 7.49982 28.712C4.72288 25.9896 3 22.196 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18Z" stroke="black" strokeWidth="2" />
            <path d="M18 25L18 15.5" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <circle cx="18" cy="11" r="1" fill="#16191E" />
        </SvgIcon>
  )
}
